import React from 'react'
import Button from '../../../components/molecules/Button/Button'
import SpendingDemandList from '../../../features/spendingDemand/components/SpendingDemandList'
import SpendingDemandUserPresenterFilter from '../../../features/spendingDemand/components/SpendingDemandList/SpendingDemandListFilter/SpendingDemandUserPresenterFilter'
import ExtractButton from '../../../features/spendingDemand/components/SpendingDemandList/ExtractButton/ExtractButton'
import PageLayout from '../../../components/organismes/PageLayout/PageLayout'
import '../SpendingDemandPage/spendingDemandListPage.scss'

export default function SpendingDemandUserListPage() {
  return (
    <PageLayout 
      title="Mes Demandes de dépenses"
      maxWidth="1200px"
      titleClassName="page--title"
    >
      <div style={{display: 'flex', justifyContent: 'space-between', gap: '10px'}}>
        <div style={{width: "40%"}}>
          <div>
            <Button label='Nouvelle demande de dépense' linkTo='/spending_demand/new' />
          </div>
          <div style={{height: '30px'}}/>
        </div>
      </div>

      <div style={{ width: "100%", marginBottom: "10px" }}>
        <ExtractButton forUser />
      </div>

      <div style={{ width: "100%", marginBottom: "10px" }}>
        <SpendingDemandUserPresenterFilter />
      </div>

      <SpendingDemandList.List withSelectMode={false} linkBase='/spending_demand_user' forUser />
    </PageLayout>
  )
}
